import { HttpClient, HttpContext } from '@angular/common/http';
import { inject } from '@angular/core';
import { createInjectable } from 'ngxtension/create-injectable';

import type { FilterInfoGetResponseType } from '@tig-dpqa-cloud/contract-backend-frontend';
import { SUPPRESS_5XX_NOTIFICATION } from '../../../core/http-error/http-error-context.tokens';

export const FilterApiService = createInjectable(() => {
  const http = inject(HttpClient);
  return {
    getFilterInfoData: () => http.get<FilterInfoGetResponseType>(
      '/api/filter-info',
      { context: new HttpContext().set(SUPPRESS_5XX_NOTIFICATION, true) },
    ),
  };
}, { providedIn: 'root' });
